import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { apiErrorMessage } from "utils/errors/parseApiError";

export interface UseRefreshMerchantReturn {
  isRefreshing: boolean;
  refreshError: string | null;
  handleRefresh: () => Promise<void>;
}

// Refresh = re-fetch the merchant React Query caches (info, balance, transactions).
// Invalidating by key prefix refetches whichever ones are currently active.
export function useRefreshMerchant(): UseRefreshMerchantReturn {
  const queryClient = useQueryClient();

  const [isRefreshing, setIsRefreshing] = useState(false);
  const [refreshError, setRefreshError] = useState<string | null>(null);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    setRefreshError(null);
    try {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["merchantInfo"] }),
        queryClient.invalidateQueries({ queryKey: ["merchantBalance"] }),
        queryClient.invalidateQueries({ queryKey: ["merchantTransactions"] }),
        queryClient.invalidateQueries({ queryKey: ["redeems"] }),
        queryClient.invalidateQueries({ queryKey: ["refunds"] }),
      ]);
    } catch (err: any) {
      setRefreshError(apiErrorMessage(err, "Failed to refresh data."));
    } finally {
      setIsRefreshing(false);
    }
  };

  return { isRefreshing, refreshError, handleRefresh };
}
